import { Controller, useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { CadastroCores } from "../../../../domain/models/cadastro_cores";
import { useEffect } from "react";
import { DefaultFormDatePickerInput } from "../../../../../../common/components/default_form_date_picker_input";
import { CadastroCoresForm, CadastroCoresSchema } from "../../../schemas/CadastroCores_lista/cadastro_cores";
import { ColorFormInput } from "./color_form_input";
import { PeriodoAnualDatePicker } from './periodo_anual_date_picker';
import { dataPeriodoEdicao } from '../../../../domain/models/periodo_anual';

/**
 * CadastroCoresModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedCadastroCores: CadastroCores | null;
  onClose: () => void;
  onSubmit: (form: any) => void;
};

export const CadastroCoresModal = ({
  open,
  saving,
  loading,
  selectedCadastroCores,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<CadastroCoresForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(CadastroCoresSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedCadastroCores) {
        hookForm.reset({
          dataCadastro: selectedCadastroCores.dataCadastro ?? new Date(),
          dataInicio: selectedCadastroCores.dataInicio ? dataPeriodoEdicao(selectedCadastroCores.dataInicio) : undefined,
          dataTermino: selectedCadastroCores.dataFinal ? dataPeriodoEdicao(selectedCadastroCores.dataFinal) : undefined,
          idCor: selectedCadastroCores.idCor ?? 0,
          cor: selectedCadastroCores.cor ?? '',
          corValor: selectedCadastroCores.corValor ?? '',
        });
      } else {
        hookForm.reset({ dataCadastro: new Date() });
      }
    }
  }, [
    open,
    selectedCadastroCores,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Cadastro de Cores"
      width="40rem"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col py-2 gap-3">
        <DefaultFormDatePickerInput
          name='dataCadastro'
          label='Data de Cadastro'
          readOnly={true}
          reactHookForm={hookForm}
        />

        <Controller
          name="dataInicio"
          control={hookForm.control}
          render={({ field, fieldState }) => (
            <PeriodoAnualDatePicker label="Dia/mês de início" value={field.value} onChange={field.onChange}
              onBlur={field.onBlur} error={fieldState.error?.message} required />
          )}
        />

        <Controller
          name="dataTermino"
          control={hookForm.control}
          render={({ field, fieldState }) => (
            <PeriodoAnualDatePicker label="Dia/mês de término" value={field.value} onChange={field.onChange}
              onBlur={field.onBlur} error={fieldState.error?.message} required />
          )}
        />

        <div className="w-full flex flex-row gap-0">
          <ColorFormInput
            colorIdName='idCor'
            colorName='cor'
            colorValue='corValor'
            label='Cor'
            required={true}
            fullWidth={true}
            reactHookForm={hookForm}
          />
        </div>
      </div>
    </BaseFormControlledModal>
  );
}
